export default {
    data() {
        return {
            user: '',
        }
    },
   
    mounted() {
        const storedIdentity = sessionStorage.getItem('identity');
        if (storedIdentity) {
            // 如果存在，将其存入 store
            this.$store.commit('setIdentity', storedIdentity);
        }
        this.user=this.$store.state.identity
    }

}